export const GRAYS = [
  { background: '#0C0B0F', textColor: '#ffffff', text: '#ffffff' },
  { background: '#1E1D20', textColor: '#ffffff', text: '#ffffff' },
  { background: '#2D2B30', textColor: '#ffffff', text: '#ffffff' }
];
